import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import {
    PostponeInfo,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import request from 'app/requests/Order/Order.requests'
import simpleApi from 'app/services/simpleApi'

type RequestParams = {
    orderNumber: string,
    data: PostponeInfo,
}

const usePostponeRequest = (onSuccess: () => void)
    : UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessPostpone,
        onError,
    } = useHandleStatusRequest({
        id: 'PostponementView',
        title: 'Order Postpone',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            orderNumber,
            data,
        }: RequestParams) => {
            return simpleApi({
                ...request.postponeOrder({
                    orderNumber,
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessPostpone,
        onError,
    })
}

export default usePostponeRequest
